export const CHECKOUT_PARAMS_PARAMETER = 'checkout_params';
export const CHECKOUT_STATUS_QUERY_PARAM = 'status';
export const FIND_FIRST_AVAILABLE_PARAMETER = 'available';
export const MAGNOLIA_PREVIEW_PARAMETER = 'mgnlPreview';
export const MAGNOLIA_CHANNEL_PARAMETER = 'mgnlChannel';
export const PACKAGE_CART_ID_PARAMETER = 'packge_cart_id';
export const VARIANT_QUERY_PROP = 'variant';
export const VARIANT_QUERY_PROP_DELIMITER = '|';
